// Site-wide switch for the installation instructions section.
// false: footer link hidden, all /:lang/installation* routes render NotFound.
// Set back to true to make the section accessible again.
export const INSTALLATION_ENABLED = false;
